var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortByAlphaAsc = function SvgSortByAlphaAsc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m2.76 14.25 3.73-9.576h1.593l3.711 9.577h-1.588l-.87-2.38H5.218l-.876 2.38zm2.923-3.676H8.82L7.333 6.4h-.131zm8.68 3.677v-1.42l5.128-6.8h-4.927V4.675h6.627v1.42l-5.097 6.8h5.147v1.357zm-1.911 5.077-2.77-2.77h5.54z"
  })));
};
export default SvgSortByAlphaAsc;